import { render } from "./Asset_Details.vue?vue&type=template&id=4b979129&scoped=true"
import script from "./Asset_Details.vue?vue&type=script&lang=js"
export * from "./Asset_Details.vue?vue&type=script&lang=js"

import "./Asset_Details.vue?vue&type=style&index=0&id=4b979129&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b979129"]])

export default __exports__